import { GetApplicationsResponse } from '@backend/students-api/routes/applications/GET/types'
import { ApiStudentRequest, request } from '../utils/request'
import { useAuthQuery } from './auth'
import { StatusInfo } from './useGetApplication'

// Extend the response type to include statusInfo at the application level
export type ApplicationWithStatusInfo = GetApplicationsResponse['data'][number] & {
  statusInfo?: StatusInfo
}

export type RawListApplicationsResponse = Omit<GetApplicationsResponse, 'data'> & {
  data: ApplicationWithStatusInfo[]
}

export enum ApplicationState {
  DRAFT = 'DRAFT',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  READY_FOR_SCREENING = 'READY_FOR_SCREENING',
  DEFERRAL_REQUESTED_IN_SCREENING = 'DEFERRAL_REQUESTED_IN_SCREENING',
  READY_FOR_ASSESSMENT = 'READY_FOR_ASSESSMENT',
  DEFERRAL_REQUESTED_IN_ASSESSMENT = 'DEFERRAL_REQUESTED_IN_ASSESSMENT',
  INITIAL_OFFER = 'INITIAL_OFFER',
  DEFERRAL_REQUESTED_IN_INITIAL_OFFER = 'DEFERRAL_REQUESTED_IN_INITIAL_OFFER',
  DECLINED = 'DECLINED',
  WAITLISTED = 'WAITLISTED',
  FINAL_OFFER_ISSUED = 'FINAL_OFFER_ISSUED',
  ENROLMENT_CONFIRMED = 'ENROLMENT_CONFIRMED',
}

export function useListApplications() {
  const { isLoading, data } = useAuthQuery(
    ['app-list'],
    async () => {
      return await request<RawListApplicationsResponse>(
        new ApiStudentRequest('/applications?page[size]=500', {
          method: 'GET',
        }),
        {
          isExpectedResponse: (res): res is RawListApplicationsResponse => res as boolean,
        },
      )
    },
    {
      enabled: true,
    },
  )

  return {
    isLoadingApplications: isLoading,
    applications: data?.data || null,
  }
}
